import { ImageData } from "~/models/image";
import { wpFetch } from "./wpfetch";
import { API_WP_IMAGES_URL } from "./base";

/**
 * Go to back end REST API to get the image data for a given image id
 *
 * @param imageId
 * @returns an array of image urls/alt text for various sizes
 */
export const fetchImageData = async (
  imageId: number,
): Promise<Record<string, ImageData> | null> => {
  try {
    const url = `${API_WP_IMAGES_URL}/${imageId}`;

    const imageData = await wpFetch(url);
    return imageData as Record<string, ImageData>;
  } catch (error) {
    console.error("Error fetching image data:", error);
    return null;
  }
};
